module.exports = __webpack_public_path__ + "static/media/train11.6b9f526b.png";